import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMatch } from "react-router";
import ErrorMessage from "../../components/ErrorMessage";
import FormInput from "../../components/FormInput";
import FormLabel from "../../components/FormLabel";
import SimpleButton from "../../components/SimpleButton";
import Spacer from "../../components/Spacer";
import { IApplicationState } from "../../store";
import { itemObservationDraftUpdate,itemsObservationsSaveRequest } from "../../store/itemsObservations/slice";
import { IItemObservation } from "../../store/itemsObservations/types";
import { Container } from "./styles";

const ItemObservationForm: React.FC = (props) => {
    const route = useMatch("/observation/:idObservation/form");

    const { t } = useTranslation();

    const idItemObservation = route?.params.idObservation;

    const itemObservation = useSelector((state: IApplicationState) =>
    state.itemsObservations.data.find((itemObservation) => itemObservation.id === idItemObservation));

    const itemsObservations = useSelector((state: IApplicationState) => state.itemsObservations);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false);

    const editingItemObservation = itemsObservations.draftItemObservation;

    const setEditingItemObservation = useCallback((itemObservation: IItemObservation) => {
        dispatch(itemObservationDraftUpdate(itemObservation));
    },[dispatch]);

    useEffect(() => {
        if (itemObservation && !isLoaded) {
            setEditingItemObservation({
            ...itemObservation,
            error: undefined,
            });
        setIsLoaded(true);
        }
    },[itemObservation, isLoaded, setEditingItemObservation]);

    if (!editingItemObservation) {
        return (
            <Container>
                <h1>{t("pages.items_observations.not_found_form")}</h1>
            </Container>
        );
    }

    return (
        <Container>
        <h1>
            {editingItemObservation.id
            ? t("pages.items_observations.edit_observation")
            : t("pages.items_observations.create_observation")}
        </h1>

        <FormLabel>{t("pages.items_observations.observation_name")}</FormLabel>
        <FormInput
            value={editingItemObservation.observation || ""}
            onChangeText={(text) => {
                setEditingItemObservation({
                    ...editingItemObservation,
                    observation: text
                });
            }}
        />

        <Spacer size={20} />

        <SimpleButton
            prependIcon="save"
            color="primary"
            disabled={editingItemObservation?.isSaving || itemsObservations.isLoading}
            onClick={() => {
                dispatch(itemsObservationsSaveRequest(editingItemObservation));
            }}
        >
            {editingItemObservation?.isSaving ? `${t("common.buttons.saving")}...`: t("common.buttons.save")}

        </SimpleButton>

        <Spacer size={20} />

        {editingItemObservation?.error && <React.Fragment>
            <ErrorMessage>{editingItemObservation.error.message}</ErrorMessage>
            <Spacer size={20} />
            </React.Fragment>}
        </Container>
    );
};

export default ItemObservationForm;
